<template>
  <div class="tier-color-field">
    <div class="tier-field-head">
      <label class="tier-field-label">{{ label }}</label>
      <span class="tier-reset" v-if="!disabled" @click="reset">Reset</span>
    </div>
    <div :class="['tier-color-box', disabled && 'is-disabled']">
      <span class="tier-color-swatch">
        <ColorPicker
          v-if="!disabled"
          :pureColor="modelValue"
          :disableAlpha="true"
          format="hex"
          @update:pureColor="update"
        />
        <i v-else class="tier-color-static" :style="{ backgroundColor: modelValue }"></i>
      </span>
      <span class="tier-color-code">{{ hex }}</span>
    </div>
  </div>
</template>

<script>
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';

export default {
  name: 'TierColorField',

  components: { ColorPicker },

  props: {
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '#000000',
    },
    default_value: {
      type: String,
      default: '#000000',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  computed: {
    hex() {
      return (this.modelValue || '').toLowerCase();
    },
  },

  methods: {
    update(color) {
      // vue3-colorpicker hands back 8 digit hex when alpha is on, trim it back to #rrggbb
      this.$emit('update:modelValue', (color || '').slice(0, 7));
    },

    reset() {
      this.$emit('update:modelValue', this.default_value);
    },
  },
};
</script>
<style lang="scss">
.tier-color-field {
  .tier-field-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 8px;

    .tier-field-label {
      margin: 0;
    }
  }

  .tier-color-box {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid var(--black-20);
    border-radius: 6px;

    &.is-disabled {
      background: var(--bg-10);
    }
  }

  .tier-color-swatch {
    display: flex;
    align-items: center;
    width: 20px;
    height: 20px;
    overflow: hidden;
    cursor: pointer;

    .vc-color-wrap,
    .vc-color {
      width: 20px;
      height: 20px;
      min-width: 20px;
      margin: 0;
      padding: 0;
      border-radius: 2px;
      box-shadow: none;
      border: 1px solid var(--black-20);
    }
  }

  .tier-color-static {
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    border: 1px solid var(--black-20);
  }

  .tier-color-code {
    font: var(--font-fg-14);
    color: var(--black-90);
  }
}
</style>
